import { StoreTeam } from "@coworker/types/lib/storeteam";
import TeamUsersTable from "./TeamUsersTable";
import TeamsTable from "./TeamsTable";
import { UserWithTeamName } from "../../types/UserWithTeamName";
import TableTabs from "./TableTabs";

interface TablesProps {
  users: UserWithTeamName[] | undefined;
  selectedTeam?: { id: string; name: string };
  teams?: StoreTeam[];
  resetFilters: () => void;
  isLoadingTeams: boolean;
  isLoadingUsers: boolean;
  handleTeamsRowClick: (teamId: string) => void;
  storeName: string;
  activeTab: number;
  changeTab: (index: number) => void;
}

const Tables = ({
  users,
  selectedTeam,
  teams,
  resetFilters,
  isLoadingTeams,
  isLoadingUsers,
  handleTeamsRowClick,
  storeName,
  activeTab,
  changeTab,
}: TablesProps) => (
  <TableTabs
    activeTab={activeTab}
    changeTab={changeTab}
    tabPanels={[
      <TeamsTable
        handleTeamsRowClick={handleTeamsRowClick}
        teams={teams || []}
        isLoading={isLoadingTeams}
        resetFilters={resetFilters}
      />,
      <TeamUsersTable
        users={users || []}
        storeName={storeName}
        selectedTeam={selectedTeam}
        isLoading={isLoadingUsers}
        resetFilters={resetFilters}
      />,
    ]}
  />
);

export default Tables;
